import { nanoid as Q } from "nanoid";
function R(t, e = 0) {
  if (typeof t != "function")
    throw new Error(
      "Throttle handler argument is incorrect. Must be a function."
    );
  let n;
  return (...s) => {
    n || (n = setTimeout(() => {
      n = void 0, t(...s);
    }, e));
  };
}
function U(t) {
  const { node: e } = t;
  if (typeof t.target == "string") {
    const n = t.target.trim().startsWith("&") ? e.element : document, s = t.target.trim().replace(/^&/, "");
    return [...n.querySelectorAll(s)];
  }
  return Array.isArray(t.target) ? t.target : t.target instanceof HTMLElement ? [t.target] : [e.element];
}
function Z(t) {
  if (!t)
    return 0;
  const e = parseFloat(t);
  return t.includes("s") ? e * 1e3 : e;
}
function j(t) {
  return typeof t == "number" ? t : Z(t);
}
const N = 16;
function L(t) {
  return t instanceof Window ? document == null ? void 0 : document.documentElement : t;
}
function tt(t, e) {
  const n = e.getBoundingClientRect();
  if (t instanceof Window)
    return n;
  const s = L(t).getBoundingClientRect();
  return {
    top: n.top - s.top,
    bottom: n.bottom - s.top,
    left: n.left - s.left,
    right: n.right - s.left,
    width: n.width,
    height: n.height
  };
}
function et(t) {
  const e = L(t), n = (e == null ? void 0 : e.scrollLeft) || window.pageXOffset, s = (e == null ? void 0 : e.scrollTop) || window.pageYOffset;
  return {
    top: s,
    bottom: s + e.clientHeight,
    left: n,
    right: n + e.clientWidth,
    height: e.clientHeight,
    width: e.clientWidth
  };
}
function W(t, e, n) {
  const s = et(e), o = tt(e, n.element), r = typeof t.threshold == "function" ? t.threshold(n) : t.threshold, c = (v) => typeof r == "number" ? r : r[["top", "right", "left", "bottom"].indexOf(v)], d = t.scrollDistance.x < 0, f = t.scrollDistance.x > 0, a = t.scrollDistance.y < 0, g = t.scrollDistance.y > 0;
  if (!n.intersecting)
    return [];
  const l = o.bottom >= c("bottom"), i = o.top <= s.height - c("top"), u = o.right >= c("right"), m = o.left <= s.width - c("left"), p = l && i && u && m, A = o.bottom < c("bottom"), y = o.top > s.height - c("top"), h = o.right < c("right"), w = o.left > s.width - c("left"), J = A || y || h || w, S = (v) => Object.entries(v).filter(([_, K]) => K).map(([_]) => _), P = S({
    in: p,
    "in-top": l,
    "in-bottom": i,
    "in-left": u,
    "in-right": m
  }), V = S({
    out: J,
    "out-top": A,
    "out-bottom": y,
    "out-left": h,
    "out-right": w
  }), E = S({
    "to-left": d,
    "to-right": f,
    "to-up": a,
    "to-down": g
  });
  return [].concat(
    V,
    V.flatMap((v) => E.map((_) => `${v}-${_}`)),
    P,
    P.flatMap((v) => E.map((_) => `${v}-${_}`))
  );
}
function b(t, e) {
  return `--jk-animation-${t}-${e}`;
}
function O(t, e) {
  if (typeof e.target == "string") {
    const n = e.target.trim().startsWith("&") ? t.element : document, s = e.target.trim().replace(/^&/, "");
    return [...n.querySelectorAll(s)];
  }
  return Array.isArray(e.target) ? e.target : e.target instanceof HTMLElement ? [e.target] : [t.element];
}
function F(t, e, n) {
  return typeof n.scrollContainer == "string" ? e.element.closest(n.scrollContainer) ?? t.scrollContainer : typeof n.scrollContainer == "function" ? n.scrollContainer() ?? t.scrollContainer : n.scrollContainer ?? t.scrollContainer ?? window;
}
function C(t, e, n, s) {
  s !== void 0 && t.style.setProperty(
    b(e, n),
    s
  );
}
function B(t) {
  return (e) => `${t.name}-${e}`;
}
function $(t, e, n) {
  return [t.name].concat(e.map(B(t))).map((s) => n[s]).filter((s) => !!s);
}
function nt(t, e) {
  C(t, e.name, "duration", 0), C(t, e.name, "delay", 0);
}
function st(t) {
  const { node: e } = t, n = O(e, t);
  for (const s of n)
    nt(s, t);
}
function H(t) {
  var o;
  const { node: e } = t, n = {
    ...(o = t.instance) == null ? void 0 : o.context.defaultAnimationOptions.cssVars,
    ...t.cssVars
  }, s = O(e, t);
  for (const r of s)
    for (const [c, d] of Object.entries(n))
      C(r, t.name, c, d.toString());
}
function ot(t) {
  var d;
  const {
    delay: e,
    duration: n,
    stagger: s,
    node: o,
    easing: r
  } = {
    ...(d = t.instance) == null ? void 0 : d.context.defaultAnimationOptions,
    ...t
  }, c = O(o, t);
  for (let f = 0; f < c.length; f++) {
    const a = c[f], g = t.timeline ? t.timeline.getDelay(t) : j(e), l = (s ? f * s : 0) + g;
    C(
      a,
      t.name,
      "duration",
      typeof n == "number" ? `${n / 1e3}s` : n
    ), C(a, t.name, "delay", `${l / 1e3}s`), C(a, t.name, "easing", r), H(t);
  }
}
function rt(t, e) {
  const { node: n } = e, s = O(n, e);
  for (const o of t)
    for (const r of s)
      r.classList.contains(o) && r.classList.remove(o);
}
function T(t, e) {
  const { node: n } = e, s = O(n, e);
  for (const o of t)
    for (const r of s)
      r.classList.contains(o) || r.classList.add(o);
}
function x(t, e, n) {
  const s = !n.initialized, o = F(t, e, n), r = n.repeatAnimation ?? t.defaultAnimationOptions.repeatAnimation;
  n.initialized || (n.initialized = !0);
  let c = e.caches.appliedClasses;
  (!c || t.scrollContainer !== o) && (c = W(t, o, e));
  const d = {
    ...t.classes,
    ...n.classes
  }, f = $(
    n,
    c.filter((l) => !l.startsWith("in")),
    d
  ), a = Object.entries(d).filter(
    ([l]) => {
      var i;
      return !((i = c == null ? void 0 : c.map(B(n))) != null && i.includes(l)) && (r || s || l.replace(`${n.name}-`, "").startsWith("out"));
    }
  ).map(([, l]) => l).filter((l) => !f.includes(l)), g = $(
    n,
    c.filter((l) => r || s || !l.startsWith("out")),
    d
  ).filter((l) => !f.includes(l));
  H(n), window.requestAnimationFrame(() => {
    s ? (st(n), T(f, n), window.requestAnimationFrame(() => {
      ot(n), window.requestAnimationFrame(() => {
        T(g, n);
      });
    })) : window.requestAnimationFrame(() => {
      rt(a, n), T(g, n);
    });
  });
}
function k(t, e) {
  if (!document.body.contains(e.element))
    return;
  const n = W(
    t,
    t.scrollContainer ?? window,
    e
  );
  e.caches.appliedClasses = n;
  for (const s of Object.values(e.animations))
    x(t, e, s);
}
function it(t, e, n) {
  const s = O(e, n), o = W(
    t,
    F(t, e, n),
    e
  );
  for (const r of s) {
    r.style.removeProperty(
      b(n.name, "duration")
    ), r.style.removeProperty(
      b(n.name, "easing")
    ), r.style.removeProperty(
      b(n.name, "delay")
    ), r.style.removeProperty(
      b(n.name, "offset")
    );
    const c = {
      ...t.defaultAnimationOptions.cssVars,
      ...n.cssVars
    };
    for (const a of Object.keys(c))
      r.style.removeProperty(
        b(n.name, a)
      );
    const d = {
      ...t.classes,
      ...n.classes
    }, f = $(n, o, d);
    for (const a of f)
      r.classList.remove(a);
  }
}
function ct(t, e) {
  const n = R(e, N), s = new ResizeObserver(n);
  return s.observe(L(t)), () => {
    s.unobserve(L(t));
  };
}
function at(t, e) {
  const n = R(e, N);
  return t.addEventListener("scroll", n), () => {
    t.removeEventListener("scroll", n);
  };
}
function lt(t, e) {
  const n = R(([...o]) => {
    e(o[0]);
  }, N), s = new IntersectionObserver(n, {
    threshold: Array.from(Array(99).keys(), (o) => o / 100 + 0.01)
  });
  return s.observe(t), () => {
    s.unobserve(t);
  };
}
function ut(t) {
  const e = L(t), n = () => ({
    x: e.scrollLeft,
    y: e.scrollTop
  }), s = {
    value: n()
  };
  return [s, () => {
    s.value = n();
  }];
}
function M(t, e) {
  const [n, s] = ut(t), o = ct(t, () => {
    s(), e(n.value);
  }), r = at(
    t,
    (c) => {
      s(), e(c);
    }
  );
  return () => {
    o(), r();
  };
}
function q(t, e) {
  const n = t.destroyers[e];
  if (n != null && n.length) {
    for (const s of n)
      s();
    delete t.destroyers[e];
  }
}
function I(t, e, n) {
  t.destroyers[e] || (t.destroyers[e] = []), t.destroyers[e].push(n);
}
function D(t, e) {
  return `${t.id}-${e.name}`;
}
function X(t) {
  var e;
  return {
    scrollContainer: void 0,
    scrollDistance: {
      x: 0,
      y: 0
    },
    defaultAnimationOptions: {
      delay: 0,
      duration: 300,
      easing: "ease",
      repeatAnimation: !0,
      ...t.defaultAnimationOptions,
      cssVars: {
        offset: "50px",
        ...(e = t.defaultAnimationOptions) == null ? void 0 : e.cssVars
      }
    },
    nodes: {},
    classes: t.classes ?? {},
    threshold: t.threshold ?? 0,
    destroyers: {}
  };
}
function ft(t) {
  const e = X(t);
  let n;
  const s = (i) => {
    q(e, typeof i == "string" ? i : i.id);
  }, o = () => !!n, r = (i, u) => {
    q(e, D(i, u));
  }, c = (i) => {
    for (const u of Object.values(i.animations))
      r(i, u);
  }, d = (i, u) => {
    r(i, u), i.animations[u.name] = u;
    const m = () => {
      it(e, i, u), delete i.animations[u.name];
    };
    if (I(e, D(i, u), m), !u.scrollContainer)
      return;
    const p = F(e, i, u);
    if (p === e.scrollContainer)
      return;
    const A = M(p, () => {
      x(e, i, u);
    }), y = () => {
      A();
    };
    I(e, D(i, u), y);
  }, f = () => {
    n == null || n(), n = void 0;
  }, a = (i) => k(e, i);
  return {
    context: e,
    isStarted: o,
    start: (i) => {
      if (n)
        return n;
      e.scrollContainer = i ?? t.target ?? window;
      const u = M(
        e.scrollContainer,
        () => {
          for (const p of Object.values(e.nodes))
            k(e, p);
        }
      ), m = () => {
        for (const p of Object.values(e.nodes))
          s(p);
      };
      return n = () => {
        u(), m();
      }, n;
    },
    addAnimation: d,
    removeNode: s,
    removeAnimation: r,
    removeAnimations: c,
    stop: f,
    addNode: (i) => {
      e.nodes[i.id] = i;
      const u = lt(
        i.element,
        (m) => {
          i.intersecting = m.isIntersecting, a(i);
        }
      );
      I(e, i.id, () => {
        c(i), u(), delete e.nodes[i.id];
      });
    },
    applyAnimations: a
  };
}
const Y = {
  "in-bottom": "_in-bottom_1345c_3",
  "in-bottom-in": "_in-bottom-in_1345c_11",
  "in-bottom-out-bottom": "_in-bottom-out-bottom_1345c_15",
  "in-bottom-out-top": "_in-bottom-out-top_1345c_18",
  "in-top": "_in-top_1345c_23",
  "in-top-in": "_in-top-in_1345c_31",
  "in-top-out-bottom": "_in-top-out-bottom_1345c_35",
  "in-top-out-top": "_in-top-out-top_1345c_38",
  "in-left": "_in-left_1345c_43",
  "in-left-in": "_in-left-in_1345c_51",
  "in-left-out": "_in-left-out_1345c_55",
  "in-right": "_in-right_1345c_60",
  "in-right-in": "_in-right-in_1345c_68",
  "in-right-out": "_in-right-out_1345c_72"
};
function dt(t) {
  if (!t)
    return ["end", 0, !1];
  const e = t.endsWith("%");
  return t[0] === "<" ? [
    "anim-start",
    parseFloat(t.replace(/<(\+=)?/, "")),
    e
  ] : t[0] === ">" ? [
    "anim-end",
    parseFloat(t.replace(/>(\+=)?/, "")),
    e
  ] : t.startsWith("+=") ? ["end", parseFloat(t.replace("+=", "")), e] : t.startsWith("-=") ? ["start", parseFloat(t.replace("+=", "")), e] : ["end", 0, !1];
}
function G(t) {
  var e;
  return {
    ...(e = t.instance) == null ? void 0 : e.context.defaultAnimationOptions,
    ...t
  };
}
function z(t) {
  if (!t)
    return 0;
  const e = G(t);
  return (U(e).length - 1) * (e.stagger ?? 0) + j(e.duration);
}
function ht() {
  let t = [];
  return {
    addAnimation: (o) => {
      t.push(o);
    },
    removeAnimation: (o) => {
      t = t.filter((r) => r.name !== o.name);
    },
    getDelay: (o) => {
      var y;
      const r = t.findIndex((h) => h.name === o.name);
      if (!r)
        return 0;
      const c = t.slice(0, r), f = c.map((h) => z(h) + j(G(h).delay)).slice(0, -1).reduce((h, w) => h + w, 0), a = f + z(c.at(-1)), g = (y = o.timelineOffset) == null ? void 0 : y.trim(), [l, i, u] = dt(g);
      let m = a, p = a;
      l === "anim-start" ? (m = f, p = a - f) : l === "anim-end" ? (m = a, p = a - f) : l === "start" ? (m = 0, p = a) : l === "end" && (m = a, p = a);
      const A = u ? p * i : i * 1e3;
      return m + A;
    }
  };
}
const mt = (t = {}) => {
  const e = ft({
    ...t,
    classes: {
      ...Y,
      ...t.classes
    }
  }), n = async (s, o, r) => {
    var i, u, m;
    const c = o.__jkAnimateId || `jk-animate-id-${Q()}`;
    o.__jkAnimateId = c;
    const d = r.arg ?? ((i = r.value) == null ? void 0 : i.name), f = r.value;
    if (!d)
      throw new Error("Missing argument to v-animate: Animation name");
    const a = ((u = r.value) == null ? void 0 : u.instance) ?? e, g = a.context.nodes[c] ?? {
      id: c,
      animations: [],
      element: o,
      caches: {}
    }, l = {
      ...f,
      node: g,
      instance: a,
      name: d
    };
    if (s === "mount")
      l.timeline && l.timeline.addAnimation(l), a.addAnimation(g, l), a.context.nodes[c] || a.addNode(g);
    else {
      const p = (m = a.context.nodes[c]) == null ? void 0 : m.animations[d];
      p && (a.context.nodes[c].animations[d] = {
        ...p,
        ...f
      });
    }
    a.isStarted() && a.applyAnimations(g);
  };
  return {
    instance: e,
    start: e.start,
    stop: e.stop,
    vAnimate: {
      mounted: (s, o) => n("mount", s, o),
      updated: (s, o) => n("update", s, o),
      unmounted(s) {
        e.removeNode(s.__jkAnimateId);
      }
    }
  };
}, yt = {
  install(t, e) {
    if (typeof process > "u" || process.client) {
      const { vAnimate: n, instance: s, start: o } = mt(e);
      o(), t.directive("animate", n), t.provide("@teamnovu/kit-animations", s);
    } else {
      const n = (...s) => {
      };
      t.directive("animate", {
        getSSRProps(s) {
          var r;
          const o = {
            ...Y,
            ...e == null ? void 0 : e.classes,
            ...(r = s.value) == null ? void 0 : r.classes
          };
          return {
            class: s.arg && o[s.arg]
          };
        }
      }), t.provide("@teamnovu/kit-animations", {
        context: X(e ?? {}),
        isStarted: !1,
        start: n,
        addAnimation: n,
        removeNode: n,
        removeAnimation: n,
        removeAnimations: n,
        stop: n,
        addNode: n,
        applyAnimations: n
      });
    }
  }
};
export {
  mt as create,
  ht as createTimeline,
  yt as default
};
